export const generateAnnotationId = () => Math.floor(Math.random() * 1000 + 1);
